import React, { useState, useEffect } from "react";
import debounce from "lodash/debounce";
import "./autocomplete-dropdwn.css";
import { BiX } from "react-icons/bi";
import ClickAwayListener from "react-click-away-listener";
import { removePhraseBetweenCommas } from "../../utils/constants";

export default function AutocompleteAddress({
  handleSelect,
  address,
  relative,
  customClassName,
  delayClose,
  handleSelectBounding,
  diffrentiateSearch,
  labelComp,
  floatingLabel,
  inherit,
  closeComponent,
  dropdownWidth,
}) {
  const [inputValue, setInputValue] = useState(address);
  const [options, setOptions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    setInputValue(removePhraseBetweenCommas(address));
  }, [address]);
  const handleClickAway = () => {
    if (delayClose) {
      setTimeout(() => {
        setShowDropdown(false);
      }, 1000);
    } else {
      setShowDropdown(false);
    }
  };

  const fetchOptions = async searchTerm => {
    let protocol = window.location.protocol;
    console.log("fetch!!! --- ");
    try {
      const latLngRes = await fetch(
        `${protocol}//nominatim.openstreetmap.org/search?q=${encodeURIComponent(
          inputValue
        )}&format=json&polygon=1&addressdetails=1`
      );
      const latLngResJson = await latLngRes.json();
      console.log("latLngResJson --- ", latLngResJson);
      // {removePhraseBetweenCommas(address.updatedValue,"CAL Fire")}
      setOptions(latLngResJson);
      setShowDropdown(true);
    } catch (error) {
      setShowDropdown(false);
      console.error("Error fetching options:", error);
    }
  };

  useEffect(() => {
    const debouncedFetchOptions = debounce(fetchOptions, 300); // Debounce delay set to 300 milliseconds

    if (inputValue) {
      if (inputValue !== address) {
        debouncedFetchOptions(inputValue);
      }
    } else {
      setOptions([]);
      setShowDropdown(false); // Clear options when inputValue is empty
    }

    return () => {
      debouncedFetchOptions.cancel(); // Cleanup debounce timer on component unmount
    };
  }, [inputValue]);

  const handleInputChange = event => {
    const value = event.target.value;
    setInputValue(removePhraseBetweenCommas(value, "CAL Fire"));
    if (!value) {
      if (diffrentiateSearch) {
        handleSelectBounding("", [], []);
      } else {
        handleSelect("", 0, 0);
      }
    }
  };

  const handleOptionClick = option => {
    setShowDropdown(false);
    setInputValue(option.display_name);

    if (diffrentiateSearch) {
      handleSelectBounding(
        removePhraseBetweenCommas(option.display_name, "CAL Fire"),
        option.boundingbox.map(x => parseFloat(x)),
        [parseFloat(option.lon), parseFloat(option.lat)]
      );
    } else {
      handleSelect(
        removePhraseBetweenCommas(option.display_name, "CAL Fire"),
        parseFloat(option.lon),
        parseFloat(option.lat)
      );
    }
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <span
        className={`event-address-dropdown ${
          floatingLabel ? "floating-label-group" : ""
        }`}
      >
        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          placeholder={
            floatingLabel ? " " : "Start typing the address or geographic area"
          }
          className={customClassName || "search-input"}
          onClick={() => (options.length ? setShowDropdown(true) : null)}
        />
        {closeComponent && closeComponent}
        {labelComp && labelComp}
        {showDropdown && (
          <ul
            style={{
              position: relative
                ? "relative"
                : inherit
                ? "inherit"
                : "absolute",
              width: dropdownWidth ? dropdownWidth : "100%",
            }}
          >
            {options.map(option => (
              <li key={option.id} onClick={() => handleOptionClick(option)}>
                {removePhraseBetweenCommas(option.display_name, "CAL Fire")}
              </li>
            ))}
          </ul>
        )}
      </span>
    </ClickAwayListener>
  );
}
